<template>
    <v-dialog v-model="dialog" max-width="400">
        <v-card>
            <v-card-title class="accent title white--text">
                Add Board
            </v-card-title>
            <v-card-text>
                <v-text-field label="Board Name" v-model="boardName"></v-text-field>
            </v-card-text>
            <v-card-actions>
                <v-spacer>
                </v-spacer>
                <v-btn @click="addBoard" class="primary">Add Board</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'AddBoardDialog',
    data () {
      return {
        boardName: '',
        dialog: false,
      }
    },
    methods: {
      openDialog() {
        this.dialog = true
      },
      async addBoard () {
        await this.$store.dispatch('addBoard', this.boardName)
        this.$store.commit('updateActiveBoard', this.boardName)
        this.dialog = false
      }
    }
  }
</script>
